// Service narrative grounded in the supplied R&D plan (PDF pp. 9–21).
// Targets and proposed integrations are not presented as measured production results.
export const AUTOMATION_STEPS = [
  {
    id: 'connect', number: '01', short: '데이터 연결', model: 'fabric', stage: 3,
    title: '흩어진 데이터가,\n하나의 기준으로.',
    description: '상품과 판매, 광고와 고객 반응. 서로 다른 곳에 쌓인 데이터를 모아 같은 상품의 이야기로 연결합니다.',
    tags: ['상품·판매 데이터', '광고·행동 데이터', '리뷰·CS'],
    output: '운영의 출발점이 되는 통합 데이터',
    scene: '서로 다른 신호를 하나의 흐름으로 정리합니다.',
  },
  {
    id: 'understand', number: '02', short: '고객 반응', model: 'xai', stage: 3,
    title: '얼마나 팔렸는지에서,\n왜 팔렸는지까지.',
    description: '리뷰와 문의 속 만족·불만 요인을 판매 성과와 함께 읽습니다. 상품의 강점과 개선할 지점을 광고 전략에 연결합니다.',
    tags: ['속성별 고객 반응', '판매 영향 요인', '개선 우선순위'],
    output: '다음 광고 전략을 위한 고객 인사이트',
    scene: '고객의 반응이 설명 가능한 요인으로 드러납니다.',
  },
  {
    id: 'forecast', number: '03', short: '수요 예측', model: 'forecast', stage: 4,
    title: '다가올 수요를 읽고,\n재고를 먼저 준비합니다.',
    description: '판매 이력에 트렌드와 고객 반응을 더해 다음 수요를 살펴봅니다. 수요 시나리오에 맞춰 재고 운영의 우선순위를 정합니다.',
    tags: ['수요 시나리오', '적정 재고 판단', '재고 리밸런싱'],
    output: '수요에 맞춘 재고 운영 기준',
    scene: '과거의 판매 흐름이 앞으로의 수요 범위로 이어집니다.',
  },
  {
    id: 'monitor', number: '04', short: '이상 감지', model: 'anomaly', stage: 4,
    title: '작은 변화도 놓치지 않고,\n대응할 이유까지.',
    description: '클릭과 전환, 판매와 재고의 변화를 함께 살핍니다. 이상 신호와 원인을 연결해 먼저 확인해야 할 일을 알려줍니다.',
    tags: ['성과 변화 감지', '원인 진단', '알림·리포트'],
    output: '우선 대응이 필요한 신호와 근거',
    scene: '평소와 다른 움직임을 찾아 중요한 신호를 분리합니다.',
  },
  {
    id: 'optimize', number: '05', short: '운영 최적화', model: 'pmf', stage: 5,
    title: '재고와 광고의 판단을,\n하나의 방향으로.',
    description: '고객 반응, 수요 전망, 운영 상태를 상품의 시장 적합성으로 함께 봅니다. 어떤 상품에 집중할지, 무엇을 개선할지 더 명확해집니다.',
    tags: ['상품 시장 적합성', '운영 우선순위', '성과 피드백'],
    output: '재고·광고 운영을 잇는 의사결정',
    scene: '여러 분석 결과가 모여 상품의 시장 적합성을 보여줍니다.',
  },
];

export const SERVICE_FAQS = [
  {
    question: '마켓핏은 어떤 데이터를 함께 보나요?',
    answer: '상품·판매·재고 데이터와 광고 지표, 리뷰·CS, 고객 행동, 시장 트렌드를 함께 보는 구조입니다. 같은 상품을 기준으로 데이터를 연결해 재고 운영과 마케팅이 공통의 근거로 판단하도록 돕습니다.',
  },
  {
    question: '재고 자동화와 광고 자동화를 왜 함께 다루나요?',
    answer: '광고로 만들어지는 수요와 실제 판매 가능한 재고는 서로 연결되어 있습니다. 마켓핏은 수요 전망과 시장 반응을 함께 분석해 재고 리밸런싱, 광고 전략, 개선 우선순위를 하나의 운영 흐름으로 이어줍니다.',
  },
  {
    question: '이 페이지에서 무엇을 체험할 수 있나요?',
    answer: '운영 화면 예시와 다섯 가지 분석 흐름을 3D로 살펴볼 수 있습니다. 자세히 보기에서 서비스 구조를 확대하고 각 구성요소의 설명과 예시 데이터를 확인할 수 있으며, 실제 광고 집행이나 발주가 실행되지는 않습니다.',
  },
];
